import apiUtils from "../utils/api-utils"
import config from "../utils/config"

const axios = apiUtils.createAxiosInstance(null, null, false, true)

function getAllLists(query) {
  return axios.get(`${config.REACT_APP_PROSPECTING_URL}/lists${query}`)
}

function deleteLists(ids) {
  return axios.post(`${config.REACT_APP_PROSPECTING_URL}/lists/bulk-delete`, { ids })
}

function exportList(id) {
  return axios.get(`${config.REACT_APP_PROSPECTING_URL}/lists/${id}/export`, {
    responseType: "blob",
  })
}

function createList(data) {
  return axios.post(`${config.REACT_APP_PROSPECTING_URL}/lists`, data)
}

export default {
  getAllLists,
  deleteLists,
  exportList,
  createList,
}
